var _path, _path2, _path3;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgIdentificationDocuments(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 15,
    height: 18,
    viewBox: "0 0 15 18",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M7.43187 6.53467C5.67295 6.53467 4.24707 7.96059 4.24707 9.71945C4.24707 11.4784 5.67295 12.9042 7.43187 12.9042C9.19081 12.9042 10.6167 11.4784 10.6167 9.71945C10.6167 7.96059 9.19081 6.53467 7.43187 6.53467ZM5.52099 9.71945C5.52099 8.66413 6.37655 7.80857 7.43187 7.80857C8.48718 7.80857 9.34274 8.66413 9.34274 9.71945C9.34274 10.7748 8.48718 11.6303 7.43187 11.6303C6.37655 11.6303 5.52099 10.7748 5.52099 9.71945Z",
    fill: "#516A93"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M5.73266 14.1781C5.38088 14.1781 5.0957 14.4633 5.0957 14.8151C5.0957 15.1668 5.38088 15.452 5.73266 15.452H9.12978C9.48155 15.452 9.76674 15.1668 9.76674 14.8151C9.76674 14.4633 9.48155 14.1781 9.12978 14.1781H5.73266Z",
    fill: "#516A93"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M10.498 0.0239119C11.905 -0.177087 13.1638 0.914678 13.1638 2.33595V3.50497C14.174 4.03895 14.8624 5.10031 14.8624 6.32243V14.8152C14.8624 16.5741 13.4365 18 11.6776 18H3.1848C1.42588 18 0 16.5741 0 14.8152V2.92532H0.00115497C0.000390617 2.9053 0 2.88518 0 2.86498C0 2.09532 0.565942 1.44278 1.32787 1.33393L10.498 0.0239119ZM1.5466 4.41157L1.53927 4.41156H1.27392V14.8152C1.27392 15.8706 2.12945 16.7261 3.1848 16.7261H11.6776C12.7329 16.7261 13.5885 15.8706 13.5885 14.8152V6.32243C13.5885 5.2698 12.7373 4.41597 11.6857 4.41157H1.5466ZM11.8899 3.13766H11.6882L11.6776 3.13764H1.54348C1.39432 3.13597 1.27392 3.01454 1.27392 2.86498C1.27392 2.72928 1.3737 2.61424 1.50803 2.59504L10.6782 1.28502C11.3177 1.19366 11.8899 1.68992 11.8899 2.33595V3.13766Z",
    fill: "#516A93"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgIdentificationDocuments);
export default __webpack_public_path__ + "static/media/identificationDocuments.5ccaabd0205a69eba17a88f8ea7fccec.svg";
export { ForwardRef as ReactComponent };